import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/transactions';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const { limit = 50, offset = 0, reason, workspace_id: workspaceId } = action.payload || {};
    const qs = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    if (reason) qs.set('reason', reason);
    if (workspaceId) qs.set('workspace_id', workspaceId);
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/transactions?${qs.toString()}`,
      { headers: getLocalUser() },
    );
    // Unwrap Flask responseJSON envelope ({data: {...}}).
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
